export default __webpack_public_path__ + "static/media/et-af.5477c9c2.svg";